var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news-container"
  }, [_c('div', {
    staticClass: "content_wrap"
  }, [_c('myImg', {
    attrs: {
      "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/banner_6.png"
    }
  }), _vm._v(" "), _c('my-tab', {
    attrs: {
      "tab-list": _vm.tabList,
      "activeIndex": _vm.activeIndex,
      "bread-title": _vm.breadTitle,
      "smallSize": ""
    },
    on: {
      "change": _vm.changeTab
    }
  }), _vm._v(" "), (_vm.activeIndex == 1 && _vm.showList) ? _c('div', {
    staticClass: "news_list_box container"
  }, [(_vm.newsList.length > 0) ? _c('b-container', [_c('b-row', _vm._l((_vm.newsList), function(v, i) {
    return _c('b-col', {
      key: i,
      attrs: {
        "md": "6",
        "lg": "4"
      },
      on: {
        "click": function($event) {
          return _vm.checkDetail(i, v)
        }
      }
    }, [_c('div', {
      staticClass: "news_list_box_item mt-40"
    }, [_c('div', {
      staticClass: "img_mask"
    }, [_c('div', [_c('i', {
      staticClass: "el-icon-search"
    })]), _vm._v(" "), _c('img', {
      staticClass: "item_img",
      attrs: {
        "src": v.img,
        "height": "230px",
        "alt": v.alt
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "mt-20 color-fff fs-20 text-overflow"
    }, [_vm._v("\n                " + _vm._s(v.title) + "\n              ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(v.date))])])])
  }), 1)], 1) : _c('div', {
    staticClass: "container text-center color-ccc mt-30 fs-30 empty-tip"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("public.nomore")) + "\n      ")])], 1) : _vm._e(), _vm._v(" "), (_vm.activeIndex == 2) ? [_c('div', {
    staticClass: "fs-24 mt-40 mb-40"
  }, [_vm._v(_vm._s(_vm.$t("public.nomore")))])] : _vm._e(), _vm._v(" "), (_vm.activeIndex == 0 && _vm.showList) ? _c('div', {
    staticClass: "news_notice container"
  }, [_c('b-container', [(_vm.noticeList.length > 0) ? _c('b-row', _vm._l((_vm.noticeList), function(v, i) {
    return _c('b-col', {
      key: i,
      attrs: {
        "md": "6",
        "lg": "4"
      },
      on: {
        "click": function($event) {
          return _vm.checkDetail(i, v)
        }
      }
    }, [(i < 9) ? _c('div', {
      staticClass: "news_list_box_item mt-40"
    }, [_c('div', {
      staticClass: "img_mask"
    }, [_c('div', [_c('i', {
      staticClass: "el-icon-search"
    })]), _vm._v(" "), _c('img', {
      staticClass: "item_img",
      attrs: {
        "src": v.img,
        "height": "230px",
        "alt": v.alt
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "mt-20 color-fff fs-20 text-overflow"
    }, [_vm._v("\n                " + _vm._s(v.title) + "\n              ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(v.date))])]) : _vm._e()])
  }), 1) : _c('div', {
    staticClass: "container text-center color-ccc mt-30 fs-30 empty-tip"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("public.nomore")) + "\n        ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.detailFlag) ? _c('div', {
    staticClass: "detail_wrap container"
  }, [(
    _vm.activeIndex == 1 ?
    _vm.newsList[_vm.curIndex].showTitle :
    _vm.noticeList[_vm.curIndex].showTitle
  ) ? _c('h1', {
    staticClass: "mt-20 mb-20 color-fff fs-30 text-center"
  }, [_vm._v("\n        " + _vm._s(_vm.activeIndex == 1 ?
    _vm.newsList[_vm.curIndex].title :
    _vm.noticeList[_vm.curIndex].title) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.activeIndex == 1 ?
        _vm.newsList[_vm.curIndex].detail :
        _vm.noticeList[_vm.curIndex].detail
      )
    }
  })]) : _vm._e()], 2), _vm._v(" "), _c('page-footer')], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-561d5eb0","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/newsCenter/index.vue
// module id = null
// module chunks = 